// extracted by mini-css-extract-plugin
export var buttonContainer = "_7p-1";
export var fontSizeSelect = "_7p-3";
export var formatSelect = "_7p-2";
export var formats = "_7p-4";
export var hidden = "_7p-5";
export var icon = "_7p-6";
export var select = "_7p-0";